var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-0"},[(_vm.productFocused)?_c('TrendingProductsClassic'):_c('TrendingEventsClassic')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }